// extracted by mini-css-extract-plugin
export default {"addressContainer":"ListingAddress_addressContainer__K840c","icon":"ListingAddress_icon__sGek4"};